/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} About_Fact_Based_ValueInputs */

const en_about_fact_based_value = /** @type {(inputs: About_Fact_Based_ValueInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Liepāja, Latvia`)
};

const lv_about_fact_based_value = /** @type {(inputs: About_Fact_Based_ValueInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Liepājā, Latvijā`)
};

/**
* | output |
* | --- |
* | "Liepāja, Latvia" |
*
* @param {About_Fact_Based_ValueInputs} inputs
* @param {{ locale?: "en" | "lv" }} options
* @returns {LocalizedString}
*/
export const about_fact_based_value = /** @type {((inputs?: About_Fact_Based_ValueInputs, options?: { locale?: "en" | "lv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<About_Fact_Based_ValueInputs, { locale?: "en" | "lv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "lv") return lv_about_fact_based_value(inputs)
	return en_about_fact_based_value(inputs)
});